import type {BioIconProps} from './common-types'

export function FlagIconsUS({...attributes}: BioIconProps) {
  return (
    <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <g clipPath="url(#clip0_712_8005)">
        <mask id="mask0_712_8005" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="16">
          <path
            d="M19 0.5H2C0.89543 0.5 0 1.39543 0 2.5V13.5C0 14.6046 0.89543 15.5 2 15.5H19C20.1046 15.5 21 14.6046 21 13.5V2.5C21 1.39543 20.1046 0.5 19 0.5Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_712_8005)">
          <path
            d="M19 0.5H2C0.89543 0.5 0 1.39543 0 2.5V13.5C0 14.6046 0.89543 15.5 2 15.5H19C20.1046 15.5 21 14.6046 21 13.5V2.5C21 1.39543 20.1046 0.5 19 0.5Z"
            fill="white"
          />
          <path fillRule="evenodd" clipRule="evenodd" d="M0 0.5H9V7.5H0V0.5Z" fill="#444379" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 1.5V2.5H2V1.5H1ZM3 1.5V2.5H4V1.5H3ZM5 1.5V2.5H6V1.5H5ZM7 1.5V2.5H8V1.5H7ZM6 2.5V3.5H7V2.5H6ZM4 2.5V3.5H5V2.5H4ZM2 2.5V3.5H3V2.5H2ZM1 3.5V4.5H2V3.5H1ZM3 3.5V4.5H4V3.5H3ZM5 3.5V4.5H6V3.5H5ZM7 3.5V4.5H8V3.5H7ZM1 5.5V6.5H2V5.5H1ZM3 5.5V6.5H4V5.5H3ZM5 5.5V6.5H6V5.5H5ZM7 5.5V6.5H8V5.5H7ZM6 4.5V5.5H7V4.5H6ZM4 4.5V5.5H5V4.5H4ZM2 4.5V5.5H3V4.5H2Z"
            fill="#A7B6E7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 0.5V1.5H21V0.5H9ZM9 2.5V3.5H21V2.5H9ZM9 4.5V5.5H21V4.5H9ZM9 6.5V7.5H21V6.5H9ZM0 8.5V9.5H21V8.5H0ZM0 10.5V11.5H21V10.5H0ZM0 12.5V13.5H21V12.5H0ZM0 14.5V15.5H21V14.5H0Z"
            fill="#ED4C49"
          />
          <path
            d="M19 1H2C1.17157 1 0.5 1.67157 0.5 2.5V13.5C0.5 14.3284 1.17157 15 2 15H19C19.8284 15 20.5 14.3284 20.5 13.5V2.5C20.5 1.67157 19.8284 1 19 1Z"
            // stroke="white"
            // strokeOpacity="0.8"
            className="border-flag stroke-white opacity-80"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_712_8005">
          <rect width="21" height="15" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
